import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AttributeValidationError } from '../../section-instance/attribute-rows/attribute-number-edit-row/attribute-number-edit-row.component';

export function getStaticTextError(
  value: string | null,
  isRequired: boolean,
  regularExpression?: string,
): AttributeValidationError | null {
  if (!value) {
    return isRequired ? { key: 'COMMON.ATTRIBUTE_VALIDATION.REQUIRED' } : null;
  }
  if (regularExpression && !new RegExp(regularExpression).test(value)) {
    return { key: 'COMMON.ATTRIBUTE_VALIDATION.INVALID_FORMAT' };
  }
  return null;
}

@Component({
  selector: 'lib-static-text-edit-row',
  standalone: false,
  templateUrl: './static-text-edit-row.component.html',
  styleUrls: ['./static-text-edit-row.component.scss'],
})
export class StaticTextEditRowComponent implements OnInit {
  @Input() label: string = '';
  @Input() originalValue: string | null | undefined;
  // Undefined until the field is edited.
  @Input() value: string | null | undefined;
  @Input() isRequired: boolean = false;
  @Input() maxLength?: number;
  @Input() placeholder: string = '';
  @Input() regularExpression?: string;
  @Output() valueChange = new EventEmitter<string | null>();
  inputValue: string = '';
  error: AttributeValidationError | null = null;

  ngOnInit(): void {
    const value = (this.value === undefined ? this.originalValue : this.value) || null;
    this.inputValue = value ?? '';
    this.validate(value);
  }

  onValueChange(value: string) {
    const newValue = value || null;
    this.valueChange.emit(newValue);
    this.validate(newValue);
  }

  // Unchanged values are not validated, except empty ones, so a required field that is still empty shows an error.
  private validate(value: string | null) {
    this.error = value !== null && value === (this.originalValue || null)
      ? null
      : getStaticTextError(value, this.isRequired, this.regularExpression);
  }
}
